import React, { useContext, useState, useEffect } from "react";
import ChatBot, { Loading } from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";
import { BusinessContext } from "../contexts/BusinessContext";

// Component for querying data via an API
const QueryAPI = ({ steps, triggerNextStep }) => {
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState("");
  const [trigger, setTrigger] = useState(true);

  const search = steps.query.value;
  const phone = steps.phone.value;
  const { business } = useContext(BusinessContext);
  const twilioPhoneNumber = business?.twilio_phone_number || "+18324791855";

  // Function to format the phone number for Twilio
  function formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^1?(\d{10})$/); // Adjusted to handle optional leading 1
    if (match) {
      return "+1" + match[1];
    }
    return null;
  }

  useEffect(() => {
    const initialise = async () => {
      setTrigger(false);
      try {
        const response = await fetch(
          "https://api.octavio.co/chat_sessions/webhook",
          {
            method: "POST",
            headers: {
              accept: "application/json",
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
              From: formatPhoneNumber(phone),
              To: twilioPhoneNumber,
              Body: search,
              Web: "true",
            }),
          }
        );

        const text = await response.text();
        console.log(text);
        const jsonStrings = text.split("}{").map((s, i, arr) => {
          if (i === 0) return s + "}";
          if (i === arr.length - 1) return "{" + s;
          return "{" + s + "}";
        });

        //const firstJson = JSON.parse(jsonStrings[0]);
        const secondJson = JSON.parse(jsonStrings[1]);

        // Assuming the second JSON contains the desired data
        if (secondJson && secondJson.current_step_message) {
          setResult(secondJson.current_step_message);
        } else {
          setResult("No result found.");
        }
        triggerNextStep({ trigger: "6" });
      } catch (error) {
        setResult("An error occurred while querying info.");
        triggerNextStep({ trigger: "query" });
      } finally {
        setLoading(false);
      }
    };
    if (trigger) initialise();
  }, [trigger, search, phone, twilioPhoneNumber, triggerNextStep]);

  return <div className="api-query">{loading ? <Loading /> : result}</div>;
};

// The main ChatBot component with an initial prompt for user details
const WidgetChatBot = () => {
  const { business } = useContext(BusinessContext);
  console.log(business);
  let bgColor = business?.color_theme || "#222";
  const theme = {
    background: "#f5f8fb",
    fontFamily: "Helvetica Neue",
    headerBgColor: bgColor,
    headerFontColor: "#fff",
    headerFontSize: "15px",
    botBubbleColor: bgColor,
    botFontColor: "#fff",
    userBubbleColor: "#fff",
    userFontColor: "#4a4a4a",
  };

  const phone_validation = (phone) => {
    var pat = new RegExp(/^(\d{3}[- .]?){2}\d{4}$|^(\d{2}[- .]?){5}$/);
    if (!pat.test(phone)) return "Invalid phone. Please try again.";
    else return true;
  };

  const steps = [
    {
      id: "0",
      message: "Hi 👋",
      trigger: "1",
    },
    {
      id: "1",
      message: "What's your cellphone?",
      trigger: "phone",
    },
    {
      id: "phone",
      user: true,
      inputAttributes: { type: "phone" },
      validator: phone_validation,
      trigger: "3",
    },
    {
      id: "3",
      message: "Great! What's your name?",
      trigger: "name",
    },
    {
      id: "name",
      user: true,
      trigger: "5",
    },
    {
      id: "5",
      message:
        "Hi {previousValue}, nice to meet you!. How can I help you today? Y tambien hablo español",
      trigger: "query",
    },
    {
      id: "query",
      user: true,
      trigger: "api-query",
    },
    {
      id: "api-query",
      component: <QueryAPI />,
      asMessage: true,
      waitAction: true,
    },
    {
      id: "6",
      message: "Do you want to ask another question?",
      trigger: "7",
    },
    {
      id: "7",
      options: [
        { value: "yes", label: "Yes", trigger: "query" },
        { value: "no", label: "No", trigger: "end-message" },
      ],
    },
    {
      id: "end-message",
      message: "Thank you! Have a great day!",
      end: true,
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <ChatBot
        floating={true}
        botDelay={1000}
        headerTitle={"Assistant for " + business?.company_name}
        placeholder={"Type your message..."}
        //handleEnd={handleEnd}
        enableMobileAutoFocus={true}
        steps={steps}
      />
    </ThemeProvider>
  );
};

export default WidgetChatBot;
